import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentService } from '../services/document.service';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { ActionsService } from '../services/actions.service';
import { SelectionModel } from '@angular/cdk/collections';
import { Request } from '../request/request.component';
import { Location } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css'],
  providers:[
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class DocumentComponent implements OnInit {
  documents:any;
  documentType:any;
  add: boolean;
  edit: boolean;
  delete: boolean;
  columns:any;
  columnsToDisplay:any;
  displayedColumns:any;
  dataSource:any; 
  selection:any;
  created_at:any;
  formattedDate:any;
  number:any;
  type:any;
  reference_number:any;
  token:string = localStorage.getItem('token');
  

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private documentService: DocumentService,private actionService: ActionsService,private dateAdapter: DateAdapter<Date>,private _location:Location) {
    this.getDocuments();
    this.getDocumentActions();
    this.getDocumentType();
    dateAdapter.setLocale('en-in');
   }

  ngOnInit() {
  }
  // tip nomer ot data kum zaqvka original i kopie 
  getDocuments(){
    this.documentService.getDocuments().subscribe(data =>{
      this.documents = data,
      console.log(this.documents);
      // console.log(data);
      this.displayedColumns =['typeName','lng','client_name','number','created_at','request_number','actions'];
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Request>(this.documents);
      this.selection = new SelectionModel<Request>(true, []);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  getDocumentActions() {
    this.actionService.moduleAction(11).subscribe(data => {
      if (data.watch_action == 1) {
        this.add = data.add_action;
        this.edit = data.edit_action;
        this.delete = data.delete_action;
      } else {
        this._location.back();
      }
    });
  }

  getDocumentType(){
    this.documentService.getDocumentType().subscribe(data =>{
      this.documentType = data
    });
  }

  filterDocuments(){
    if(this.created_at){
      this.formattedDate = new Date(this.created_at).toLocaleDateString('en-GB');
    }
    var data = {
      number:this.number,
      created_at:this.formattedDate,
      type:this.type,
      reference_number:this.reference_number,
    }

    this.documentService.getFilterDocuments(data).subscribe(resp =>{
      
      this.documents = resp,
      this.displayedColumns =['typeName','lng','client_name','number','created_at','request_number','actions'];
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Request>(this.documents);
      this.selection = new SelectionModel<Request>(true, []);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

}
